import { QantasRewardsService } from './services/qantas-rewards.service';
import { BreadcrumbService } from './services/breadcrumb.service';
import { ErrorInterceptor } from './shared/errorHandler.interceptor';
import { LoadingScreenService } from './services/loading-screen.service';
import { LoadingScreenInterceptor } from './shared/loading-screen/loading.interceptor';
import { ManagePerpetualsModule } from './manage-perpetuals/manage-perpetuals.module';
import { ManageSubscriptionsModule } from './manage-subscriptions/manage-subscriptions.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal, NgbCarouselModule, NgbPopoverModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { HomePageComponent } from './home/home.page.component';
import { UsermanagementComponent } from './usermanagement/usermanagement.component';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { NavbarComponent } from './nav/navbar/navbar.component';
import { SearchService } from './services/search.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CatalogueService } from './services/catalogue.service';
import { SidebarComponent } from './nav/sidebar/sidebar.component';
import { UserComponent } from './nav/nav-components/user/user.component';
import { HelpComponent } from './nav/nav-components/help/help.component';
import { LocationComponent } from './nav/nav-components/location/location.component';
import { SettingComponent } from './nav/nav-components/setting/setting.component';
import { NavModule } from './nav/nav.module';
import { PersonInfoComponent } from './account/person-info/person-info.component';
import { SalesDocComponent } from './account/sales-doc/sales-doc.component';
import { DeleteSubscriptionsComponent } from './account/subscriptions/subscriptions.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AdsModule } from './adcomponents/ad.module';
// third party package
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { WatchListService } from './services/watch-list.service';
import { ShoppingCartService } from './services/shopping-cart.service';
import { CommonService } from './services/common.service';
import { AuthService } from './services/auth.service';
import { HttpService } from './services/http.service';
import { ProductService } from './services/product.service';
import { WatcherService } from './services/watcher.service';
import { FeedBackComponent } from './nav/nav-components/feed-back/feed-back.component';
import { EventListenerService } from './services/close-listenenr.service';
import { ShoppingCartComponent } from './nav/nav-components/shopping-cart/shopping-cart.component';
import { DigitalWalletComponent } from './account/digital-wallet/digital-wallet.component';
import { FileService } from './services/file.service';
import { CheckOutService } from './services/checkout.service';
import { MyAccountService } from './services/myAccount.service';
// TODO: dont't import Angular Lazy loaded module.
import { MyCartsModule } from './my-carts/my-carts.module';
import { MyAccountModule } from './my-account/my-account.module';
import { QuotesModule } from './quotes/quotes.module';
import { ReportingModule } from './reporting/reporting.module';
import { ToolsModule } from './tools/tools.module';
import { PromotionsModule } from './promotions/promotions.module';
import { EventsModule } from './events/events.module';
import { CataloguesV2Module } from './catalogues-v2/catalogues-v2.module';
import { KbModule } from './kb/kb.module';
import { MicrositesModule } from './microsites/microsites.module';
// import { AdminModule } from './admin/admin.module';
import { AboutInfoModule } from './about-info/about-info.module';
import { MyOrderModule } from './my-orders/my-order.module';
// End of Angular lazy load modules
import { RoutingModule } from './app.routing';
import { Ng2CompleterModule } from 'ng2-completer';
import { CmsStudioModule } from './cms/cms.module';
//import { ManageRenewalsModule } from './manage-renewals/manage-renewals.module';
//import { ManageRenewalsNewModule } from './manage-renewals-new/manage-renewals-new.module';
import { MicrosoftCloudAgreementComponent } from './popup-collection/microsoft-cloud-agreement/microsoft-cloud-agreement.component';
import { TermsAndConditionsComponent } from './popup-collection/terms-and-conditions/terms-and-conditions.component';
import { AddSubscriptionComponent } from './popup-collection/add-subscription/add-subscription.component';
import { AddPerpetualComponent } from './popup-collection/add-perpetual/add-perpetual.component';
import { AddAzureRiComponent } from './popup-collection/add-azure-ri/add-azure-ri.component';
import { MessageService } from './services/message.service';
import { AddAddonComponent } from './popup-collection/add-addon/add-addon.component';
import { AliasLoginComponent } from '../app/nav/nav-components/user/user.component';
import { CustomReportEditComponent } from './reporting/custom-report-edit/custom-report-edit.component';
import { ConfirmSubscriptionComponent } from './popup-collection/confirm-subscription/confirm-subscription.component';
import { FinishSubscriptionComponent } from './popup-collection/finish-subscription/finish-subscription.component';
import { SharedModule } from './shared/shared.module';
import { ConfirmPerpetualComponent } from './popup-collection/confirm-perpetual/confirm-perpetual.component';
import { FinishPerpetualComponent } from './popup-collection/finish-perpetual/finish-perpetual.component';
import { ConfirmSoftwareComponent } from './popup-collection/confirm-software/confirm-software.component';
import { FinishSoftwareComponent } from './popup-collection/finish-software/finish-software.component';
import { ConfirmAzureRiComponent } from './popup-collection/confirm-azure-ri/confirm-azure-ri.component';
import { FinishAzureRiComponent } from './popup-collection/finish-azure-ri/finish-azure-ri.component';
import { FinanceModule } from './finance/finance.module';
import { ErrorPageComponent } from './error-page/error-page.component';
import { FiltersComponent } from './reporting/filters/filters.component';
import { FilterSubsectionComponent } from './reporting/filters/filter-subsection/filter-subsection.component';
import { SchedulingComponent } from './reporting/scheduling/scheduling.component';
import { SummaryComponent } from './reporting/summary/summary.component';
import { FinanceQuotesModule } from './finance-quotes/finance-quotes.module';
// import { AddKaspSubscriptionComponent } from './manage-subscriptions/manage-kasp-details/add-kasp-subscription/add-kasp-subscription.component';
import { ConfirmKaspSubscritptionsComponent } from './popup-collection/confirm-kasp-subscritptions/confirm-kasp-subscritptions.component';
import { FinishKaspSubscriptionComponent } from './popup-collection/finish-kasp-subscription/finish-kasp-subscription.component';
import { DeleteConfirmComponent } from './popup-collection/delete-confirm/delete-confirm.component';
import { AirFreightTermsComponent } from './popup-collection/air-freight-terms/air-freight-terms.component';
import { EncodeHttpParamsInterceptor } from './shared/encodeHttpParams.interceptor';
import { FeedbackComponent } from './home/feedback/feedback.component';
import { CmsWrapperModule } from './shared/cmswrapper/cmswrapper.module';
import { ToastComponent } from './shared/toast/toast.component';
import { NewsletterEditProductComponent } from './popup-collection/newsletter-edit-product/newsletter-edit-product.component';
import { NewsletterEditUrlComponent } from './popup-collection/newsletter-edit-url/newsletter-edit-url.component';
import { NewsletterEditHeadingComponent } from './popup-collection/newsletter-edit-heading/newsletter-edit-heading.component';
import { NewsletterEditCommentComponent } from './popup-collection/newsletter-edit-comment/newsletter-edit-comment.component';
import { OrderItemDetailComponent } from './my-orders/order-item-detail/order-item-detail.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AssociationInvitationComponent } from './popup-collection/association-invitation/association-invitation.component';
import { SendEnquiryComponent } from './popup-collection/send-enquiry/send-enquiry.component';
import { NewsletterEditNameComponent } from './popup-collection/newsletter-edit-name/newsletter-edit-name.component';
import { NewsletterEditSectionNameComponent } from './popup-collection/newsletter-edit-section-name/newsletter-edit-section-name.component';
import { NewsletterDeleteSectionComponent } from './popup-collection/newsletter-delete-section/newsletter-delete-section.component';
import { NewsletterPromoNameComponent } from './popup-collection/newsletter-promo-name/newsletter-promo-name.component';
import { NewsletterPromoAreaComponent } from './popup-collection/newsletter-promo-area/newsletter-promo-area.component';
import { NewsletterPromoImageComponent } from './popup-collection/newsletter-promo-image/newsletter-promo-image.component';
import { ConfirmSplaOrderComponent } from './popup-collection/confirm-spla-order/confirm-spla-order.component';
import { ConfirmMnpidComponent } from './popup-collection/confirm-mnpid/confirm-mnpid.component';
import { NgbDateCustomParserFormatter } from './shared/NgbDateParserFormatter';

// ngrx
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers } from './reducers/index';
import { WatchListEffects } from './effects/watchlist.effect';
import { ShoppingCartEffects } from './effects/shoppingcart.effect';
import { MfaAuthenticationComponent } from './popup-collection/mfa-authentication/mfa-authentication.component';
import { EnableMfaComponent } from './popup-collection/enable-mfa/enable-mfa.component';
import { UpdateEmailMobileComponent } from './popup-collection/update-email-mobile/update-email-mobile.component';
import { ManageRenewalsPortalModule } from './manage-renewals-portal/manage-renewals-portal.module';
import { RewardsComponent } from './rewards/rewards.component';
import { RewardsModule } from './rewards/rewards.module';
import {DigitalWalletEffects} from './effects/digitalwallet.effect';
import { ChildHeaderModule } from './child-header/child-header.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BreadcrumbModule } from './breadcrumb/breadcumb.module';
import { NgProgressService } from './services/ngProgress.service';
import { NguiDatetimePickerModule } from '@ngui/datetime-picker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { NgxSortableModule } from 'ngx-sortable';
import { MatSortModule } from '@angular/material/sort';
import { ConfirmNCESubscriptionComponent } from './popup-collection/confirm-nce-subscription/confirm-nce-subscription.component';
import { CSPConditionCheckComponent } from './popup-collection/csp-condition-check/csp-condition-check.component';
import { ConfirmNCEQtyComponent } from './popup-collection/confirm-nce-qty/confirm-nce-qty.component';
import { MigrateToNCEComponent } from './popup-collection/migrate-to-nce/migrate-to-nce.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ConfirmAutodeskSwitchComponent } from './popup-collection/confirm-autodesk-switch/confirm-autodesk-switch.component';
import { SimpleMsgPopupComponent } from './popup-collection/simple-msg/simple-msg-popup.component';
// import { ToastyModule } from 'ng2-toasty';
import { PanelService } from './services/panel.service';
import { PortalModule } from '@angular/cdk/portal';
import { TenantAssociationComponent } from './popup-collection/tenant-association-popup/tenant-association-popup.component';
import { ConfirmARCreationPopup } from './popup-collection/comfirm-ar-creation-popup/confirm-ar-creation-popup.component';
import { ConfirmMASSubCreationPopup } from './popup-collection/comfirm-mas-sub-creation-popup/comfirm-mas-sub-creation-popup.component';
import { CalculateRIReturnPopupComponent } from './popup-collection/calculate-ri-return-popup/calculate-ri-return-popup.component';
import { SimpleLoadingPopupComponent } from './popup-collection/simple-loading/simple-loading-popup.component';
import { CataloguesModule } from './catalogues/catalogues.module';
import { ConfirmWGSCreateComponent } from './popup-collection/confirm-wgs-create/confirm-wgs-create.component';
import { FinishWGSCreateComponent } from './popup-collection/finish-wgs-create/finish-wgs-create.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmAMPSubscriptionPopup } from './popup-collection/confirm-amp-subscription-popup/confirm-amp-subscription-popup.component';
import { ConfirmAMPQtyComponent } from './popup-collection/confirm-amp-qty/confirm-amp-qty.component';
import { ConfirmAMPSubscriptionCancelComponent } from './popup-collection/confirm-amp-subscription-canel/confirm-amp-subscription-cancel.component';
import { FinishAMPSubscriptionComponent } from './popup-collection/finish-amp-subscription/finish-amp-subscription.component';
import { AMPSubTransferFinishComponent } from './popup-collection/amp-sub-transfer-finish/amp-sub-transfer-finish.component';
import { AMPAssociateFinishComponent } from './popup-collection/amp-associate-finish/amp-associate-finish.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ConfirmUpgradePopUpComponent } from './popup-collection/confirm-upgrade-pop-up/confirm-upgrade-pop-up.component';
import { ConfirmRenewalPopUpComponent } from './popup-collection/confirm-renewal-pop-up/confirm-renewal-pop-up.component';
import { ConfirmAMPConsumablePopup } from './popup-collection/confirm-amp-consumable-popup/confirm-amp-consumable-popup.component';
import { CustomersModule } from './customers/customers.module';
import { ChatBotComponent } from './nav/nav-components/chat-bot/chat-bot.component';
// import { Windows11AssessementComponent } from './windows-11-assessment/windows-11-assessment.component';
import { Windows11AssessmentModule } from './windows-11-assessment/windows-11-assessment.module';
import { Windows11AssessmentService } from './services/windows-11-assessment.service';



@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    HelpComponent,
    ChatBotComponent,
    LocationComponent,
    FeedBackComponent,
    UsermanagementComponent,
    UserprofileComponent,
    SettingComponent,
    UserComponent,
    NavbarComponent,
    SidebarComponent,
    PersonInfoComponent,
    SalesDocComponent,
    ShoppingCartComponent,
    DigitalWalletComponent,
    DeleteSubscriptionsComponent,
    // MicrosoftCloudAgreementComponent,
    // TermsAndConditionsComponent,
    AddSubscriptionComponent,
    AddPerpetualComponent,
    AddAzureRiComponent,
    AddAddonComponent,
    // AddKaspSubscriptionComponent,
    AliasLoginComponent,
    ConfirmSubscriptionComponent,
    ConfirmAMPSubscriptionPopup,
    ConfirmAMPConsumablePopup,
    ConfirmWGSCreateComponent,
    FinishSubscriptionComponent,
    FinishAMPSubscriptionComponent,
    FinishWGSCreateComponent,
    ConfirmPerpetualComponent,
    FinishPerpetualComponent,
    ConfirmSoftwareComponent,
    FinishSoftwareComponent,
    ConfirmAzureRiComponent,
    FinishAzureRiComponent,
    ErrorPageComponent,
    ConfirmKaspSubscritptionsComponent,
    FinishKaspSubscriptionComponent,
    DeleteConfirmComponent,
    AirFreightTermsComponent,
    FeedbackComponent,
    NewsletterEditProductComponent,
    NewsletterEditUrlComponent,
    NewsletterEditHeadingComponent,
    NewsletterEditCommentComponent,
    AssociationInvitationComponent,
    SendEnquiryComponent,
    NewsletterEditNameComponent,
    NewsletterEditSectionNameComponent,
    NewsletterDeleteSectionComponent,
    NewsletterPromoNameComponent,
    NewsletterPromoAreaComponent,
    NewsletterPromoImageComponent,
    // ConfirmSplaOrderComponent,
    ConfirmMnpidComponent,
    MfaAuthenticationComponent,
    EnableMfaComponent,
    UpdateEmailMobileComponent,
    ConfirmNCESubscriptionComponent,
    ConfirmUpgradePopUpComponent,
    ConfirmRenewalPopUpComponent,
    ConfirmAMPSubscriptionCancelComponent,
    ConfirmNCEQtyComponent,
    ConfirmAMPQtyComponent,
    AMPSubTransferFinishComponent,
    AMPAssociateFinishComponent,
    CSPConditionCheckComponent,
    MigrateToNCEComponent,
    ConfirmAutodeskSwitchComponent,
    SimpleMsgPopupComponent,
    SimpleLoadingPopupComponent,
    TenantAssociationComponent,
    ConfirmARCreationPopup,
    ConfirmMASSubCreationPopup,
    CalculateRIReturnPopupComponent,
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPopoverModule,
    NgbTooltipModule,
    NgbCarouselModule,
    // NgxSortableModule,
    NavModule,
    AdsModule,
    MatSnackBarModule,
    NgProgressModule,
    NgProgressHttpModule,
    // TODO: these module shouldn't import here, which will cause router overwrite problem in Angular Lazy Loading
    MyAccountModule,
    MyCartsModule,
    QuotesModule,
    ReportingModule,
    ToolsModule,
    PromotionsModule,
    RewardsModule,
    EventsModule,
    Windows11AssessmentModule,
    // To change between which catalogues are used, uncomment CataloguesModule and comment out CataloguesV2Module
    // CataloguesModule,
    CataloguesV2Module,
    KbModule,
    MicrositesModule,
    // AdminModule,
    AboutInfoModule,
    MyOrderModule,
    // End of Angular Lazy Loading modules
    RoutingModule,
    ManageSubscriptionsModule,
    CustomersModule,
    ManagePerpetualsModule,
    //ManageRenewalsModule,
    //ManageRenewalsNewModule,
    ManageRenewalsPortalModule,
    Ng2CompleterModule,
    CmsStudioModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatSnackBarModule,
    MatRadioModule,
    MatSelectModule,
    MatIconModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatSlideToggleModule,
    SharedModule,
    FinanceModule,
    FinanceQuotesModule,
    CmsWrapperModule,
    NgSelectModule,
    ChildHeaderModule,
    BreadcrumbModule,
    PortalModule,
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateSerializability: true,
            strictActionSerializability: true,
            strictActionWithinNgZone: true,
            strictActionTypeUniqueness: true,
            strictStateImmutability: false,
            strictActionImmutability: false
      },
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25
    }),
    EffectsModule.forRoot([
      WatchListEffects,
      ShoppingCartEffects,
      DigitalWalletEffects
    ])
    // ToastyModule.forRoot()
  ],

  providers: [
    PanelService,
    NgProgressService,
    NguiDatetimePickerModule,
    EventListenerService,
    SearchService,
    CatalogueService,
    ProductService,
    WatchListService,
    ShoppingCartService,
    AuthService,
    FileService,
    CommonService,
    Windows11AssessmentService,
    HttpService,
    WatcherService,
    CheckOutService,
    MessageService,
    MyAccountService,
    LoadingScreenService,
    BreadcrumbService,
    QantasRewardsService,
    NgbActiveModal,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingScreenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: NgbDateParserFormatter,
      useClass: NgbDateCustomParserFormatter
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-AU' }

  ],

  bootstrap: [AppComponent],

  entryComponents: [
    HelpComponent,
    ChatBotComponent,
    LocationComponent,
    SettingComponent,
    // this is inside the nav
    UserComponent,
    UserprofileComponent,
    PersonInfoComponent,
    SalesDocComponent,
    ShoppingCartComponent,
    FeedBackComponent,
    DigitalWalletComponent,
    DeleteSubscriptionsComponent,
    AliasLoginComponent,
    CustomReportEditComponent,
    ConfirmSubscriptionComponent,
    ConfirmAMPSubscriptionPopup,
    ConfirmAMPConsumablePopup,
    ConfirmWGSCreateComponent,
    FinishSubscriptionComponent,
    FinishWGSCreateComponent,
    ConfirmPerpetualComponent,
    FinishPerpetualComponent,
    ConfirmSoftwareComponent,
    FinishSoftwareComponent,
    ConfirmAzureRiComponent,
    FinishAzureRiComponent,
    FiltersComponent,
    FilterSubsectionComponent,
    SchedulingComponent,
    SummaryComponent,
    ConfirmKaspSubscritptionsComponent,
    FinishKaspSubscriptionComponent,
    DeleteConfirmComponent,
    AirFreightTermsComponent,
    ToastComponent,
    NewsletterEditProductComponent,
    NewsletterEditUrlComponent,
    NewsletterEditHeadingComponent,
    NewsletterEditCommentComponent,
    AssociationInvitationComponent,
    SendEnquiryComponent,
    NewsletterEditNameComponent,
    NewsletterEditSectionNameComponent,
    NewsletterDeleteSectionComponent,
    NewsletterPromoNameComponent,
    NewsletterPromoAreaComponent,
    NewsletterPromoImageComponent,
    ConfirmMnpidComponent,
    MfaAuthenticationComponent,
    EnableMfaComponent,
    UpdateEmailMobileComponent,
    ConfirmNCESubscriptionComponent,
    ConfirmUpgradePopUpComponent,
    ConfirmRenewalPopUpComponent,
    ConfirmAMPSubscriptionCancelComponent,
    ConfirmNCEQtyComponent,
    ConfirmAMPQtyComponent,
    AMPSubTransferFinishComponent,
    AMPAssociateFinishComponent,
    CSPConditionCheckComponent,
    MigrateToNCEComponent,
    SimpleMsgPopupComponent,
    SimpleLoadingPopupComponent,
    TenantAssociationComponent,
    ConfirmARCreationPopup,
    ConfirmMASSubCreationPopup,
    CalculateRIReturnPopupComponent
  ]
})

export class AppModule { }
